import { forwardRef } from 'react';
import { Button, ButtonProps } from '@osmosis/tailwind-ui/components/Button';
import { textBlue } from '@osmosis/tailwind-ui/styles/text';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';

/**
 * Pill link to the plans page used on logged-out library surfaces. Filled with
 * the primary-text blue by default. Callers can override the fill or sizing by
 * passing classes via `className`, as the library header does.
 */
export const LibraryLoggedOutPrime = forwardRef<HTMLElement, ButtonProps>(
  function LinkButton({ className, children, ...props }, ref): JSX.Element {
    return (
      <Button
        as="a"
        ref={ref}
        href="/plans?source_cta=library-logged-out"
        color={'white'}
        rounded
        data-testid="library.logged-out-prime"
        {...props}
        className={cn(textBlue, 'mb-2', className)}
      >
        {children}
      </Button>
    );
  },
);
